const gallery = document.querySelector('.gallery');
const trigger = document.querySelector('.gallery-trigger');

if (gallery && trigger) {
    const postId = gallery.dataset.postId;

    let loading = false;
    let offset = parseInt(global.photos_per_load);

    const observer = new IntersectionObserver(async ([entry]) => {
        if (!entry.isIntersecting || loading) {
            return;
        }

        loading = true;
        observer.unobserve(trigger);

        const response = await fetch(
            '/wp-admin/admin-ajax.php?action=load_gallery&post_id=' + postId + '&offset=' + offset
        );

        const html = await response.text();

        if (html.trim()) {
            gallery.insertAdjacentHTML(
                'beforeend',
                html
            );

            offset += parseInt(global.photos_per_load);
            loading = false;

            observer.observe(trigger);
        }
    });

    observer.observe(trigger);
}